module.exports = __webpack_public_path__ + "static/img/success.ce826577.png";